import React, { Component } from "react";
import ErrorIcon from "../../images/error.svg";
import "./styles.scss";
import { SpaceBox } from "../Space";

const imgScale = {
  width: "64px",
  height: "64px"
};
const Icon = props => (
  <img className={props.className} src={props.src} {...imgScale} />
);

export default class PaymentErrorModalComponent extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    const { show, hideModal, title, message } = this.props;
    return (
      <Modal show={show}>
        <div className="form-wrapper">
          <div className="form-group title mt-0 mb-0">
            <Icon src={ErrorIcon} />
            <h6 className="title">{title}</h6>
            <label className="message">{message}</label>
            <SpaceBox h='80px' w="1px" />
            <button className="btn btn-primary w-100" onClick={hideModal}>ชำระเบี้ยอีกครั้ง</button>
            <SpaceBox h='12px' w="1px" />
            <button className="btn w-100" onClick={() => window.location = '/?callback=1'}>ยกเลิก</button>
          </div>
        </div>
      </Modal>
    )
  }
}

const Modal = ({ show, children }) => {
  const showHideClassName = show ? "modal display-block" : "modal display-none";

  return (
    <div className={ `modal-payment-error ${showHideClassName}`}>
      <section className="modal-main">
        {children}
      </section>
    </div>
  );
};
